/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RefreshTileRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'
import {RefreshTileResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'


export const refreshTile = (request: RefreshTileRequest, options?: CashRequestOptions) => post<RefreshTileRequest, RefreshTileResponse>("/2.0/cash/refresh-tile", request, {...options, rejectOnError: true })